import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DataListPage from "../../../components/DataListPage";
import TruncatedCell, { TruncatedLink } from "../../../components/TruncatedCell";
import bannerService from "../../../services/bannerService";
import { instanceToken } from "../../../utils/constant";

export default function Banners() {
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [offset, setOffset] = useState(0);
  const [count, setCount] = useState(0);
  const [banners, setBanners] = useState(null);

  useEffect(() => {
    fetchBanners(rowsPerPage, offset);
  }, [offset, rowsPerPage]);

  const fetchBanners = async (limit, offset) => {
    try {
      const res = await bannerService.getAllBanners(
        instanceToken.token,
        limit,
        offset
      );
      parse(res.data);
    } catch (error) {
      console.log(error);
      throw new Error(error);
    }
  };

  const parse = (data) => {
    setBanners(data.banner_images);
    setCount(data.count);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setOffset(rowsPerPage * newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    setOffset(0);
  };

  const openDetail = (row) => navigate(`/banners/${row.id}`);

  const columns = [
    { id: "id", label: "ID", render: (row) => row.id },
    {
      id: "name_en",
      label: "Name (English)",
      render: (row) => <TruncatedCell value={row.name_en} />,
    },
    {
      id: "name_mm",
      label: "Name (Myanmar)",
      render: (row) => <TruncatedCell value={row.name_mm} myanmar />,
    },
    {
      id: "link",
      label: "Link",
      render: (row) => (
        <TruncatedLink href={row.link} value={row.link} />
      ),
    },
  ];

  return (
    <DataListPage
      title="Banners"
      rows={banners || []}
      columns={columns}
      count={count}
      page={page}
      rowsPerPage={rowsPerPage}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      createButton={{
        label: "Create",
        onClick: () => navigate("/createBanner"),
      }}
      onView={openDetail}
      menuActions={[{ label: "View details", onClick: openDetail }]}
      loading={!banners}
    />
  );
}
